<template>
  <div class="hs-skeleton" :class="[`hs-skeleton--${variant}`]" :style="styleObject" />
</template>

<script>
export default {
  name: "HsSkeleton",
  props: {
    variant: {
      type: String,
      default: "line",
      validator: (value) => ["line", "circle", "card"].includes(value),
    },
    width: { type: String, default: "" },
    height: { type: String, default: "" },
  },
  computed: {
    styleObject() {
      return {
        width: this.width || undefined,
        height: this.height || undefined,
      };
    },
  },
};
</script>

<style scoped>
.hs-skeleton {
  animation: hs-skeleton-pulse 1.4s ease-in-out infinite;
  background: linear-gradient(90deg,
    color-mix(in srgb, var(--hs-border, #cbd5e1) 65%, transparent),
    color-mix(in srgb, var(--hs-primary, #3293ec) 10%, transparent),
    color-mix(in srgb, var(--hs-border, #cbd5e1) 65%, transparent));
  background-size: 200% 100%;
}

.hs-skeleton--line {
  border-radius: 999px;
  height: 0.9rem;
}

.hs-skeleton--circle {
  border-radius: 999px;
  height: 3rem;
  width: 3rem;
}

.hs-skeleton--card {
  border-radius: 22px;
  height: 8rem;
  width: 100%;
}

@keyframes hs-skeleton-pulse {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>
